import React from 'react'

import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipToggle,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { Locations, PageSource } from '@mc/track-event'

import { trackCtaPurchaseClick } from '../../events'

type TooltipCtaProps = {
  disabled: boolean
  fullWidth?: boolean
  href: string
  action: 'Submit My Picks' | 'Continue'
  onClick(): void
  children: string
  location?: typeof Locations.HERO | typeof Locations.QUIZ_MODULE
  pageSource?: typeof PageSource.HOME | typeof PageSource.CLASS_PAGE
}

export const TooltipCta = ({
  disabled,
  fullWidth = false,
  href,
  action,
  onClick,
  children,
  location,
  pageSource,
}: TooltipCtaProps) => {
  const { t } = useTranslation('@mc/next')

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) {
      e.preventDefault()
      return
    }
    trackCtaPurchaseClick({ action, href, location, pageSource })
    onClick()
  }

  return (
    <Tooltip>
      <TooltipToggle>
        <Button
          // a11y link disabling: https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
          as='a'
          role='link'
          aria-disabled={disabled ? true : undefined}
          href={disabled ? undefined : href}
          onClick={handleClick}
          fullWidth={fullWidth}
        >
          {children}
        </Button>
      </TooltipToggle>
      {disabled && (
        <TooltipContent>{t('home.hero.cta.disabledTooltip')}</TooltipContent>
      )}
    </Tooltip>
  )
}
